const configPost = {
    postDetail: {
        detailLayout: 'PostDetailDefaultLayout',
        detailApiParamSet: {
            caf: 1,
            li: 1,
            cmt: 1,
            ju: 1,
            jud: 1,
            ht: 1,
            la: 1,
            wr: 1,
            th: 1,
            im: 1,
        },
        getFunc: 'getPost',

        deleteFunc: 'deletePost',
        deleteApiParamSet: {},
        deleteSuccessType: 500,
        deleteErrorTypes: {},
        keyName: 'wr_id',
        sendType: 'post',
    },
    postComment: {
        getFunc: 'getPostComment',
        filterLayout: 'CommentFilterDefaultLayout',
        listLayout: 'CommentListDefaultLayout',
        paginationLayout: 'LazyloadLoadingLayout',
        listApiParamSet: {
            ip: 1,
            obt: 'created_at',
            obs: 'desc',
            cwr: 1,
            mt: 1,
        },
        pageRow: 10,
    },
    liveDetail: {
        detailLayout: 'PostDetailLiveLayout',
        detailApiParamSet: {
            ip: 0,
            wr: 1,
            caf: 1,
            la: 1,
            ht: 1,
            ju: 1,
            th: 1
        },
        getFunc: 'getLive',

        deleteFunc: 'deleteLive',
        deleteApiParamSet: {},
        deleteSuccessType: 500,
        deleteErrorTypes: {},
        keyName: 'wr_id',
        sendType: 'live',
    },
    endLiveDetail: {
        detailLayout: 'PostDetailEndLiveLayout',
        detailApiParamSet: {
            ip: 0,
            wr: 1,
            caf: 1,
            la: 1,
            ht: 1,
            ju: 1,
            th: 1
        },
        getFunc: 'getLive',

        deleteFunc: 'deleteLive',
        deleteApiParamSet: {},
        deleteSuccessType: 500,
        deleteErrorTypes: {},
        keyName: 'wr_id',
        sendType: 'live',
    },
}

export default {
    methods: {
        returnPostConfig(type) {
            return configPost[type];
        },
    },
    filterConfig: {
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        }
    }
}
